import React from 'react';
import { Tooltip } from '@mui/material';
import type { TooltipProps } from '@mui/material/Tooltip';
import type { SxProps, Theme } from '@mui/material/styles';
import { Info as InfoIcon, InfoOutlined } from '@mui/icons-material';

type InfoVariant = 'outlined' | 'solid';

type InfoProps = Omit<TooltipProps, 'title' | 'children'> & {
    variant?: InfoVariant;
    className?: string;
    sx?: SxProps<Theme>;
    children: React.ReactNode;
    renderHtml?: boolean;
};

const Info = ({ variant = 'outlined', className, sx, children, renderHtml = false, ...tooltipProps }: InfoProps) => {
    const Icon = variant === 'solid' ? InfoIcon : InfoOutlined;
    const tooltipTitle =
        renderHtml && typeof children === 'string' ? <span dangerouslySetInnerHTML={{ __html: children }} /> : children;

    return (
        <Tooltip enterTouchDelay={0} {...tooltipProps} title={tooltipTitle}>
            <Icon className={className} sx={sx} />
        </Tooltip>
    );
};

export default Info;
